module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hans_4-5391103002d689695f3d09661a6b8f33.jpg";